// extracted by mini-css-extract-plugin
module.exports = {"panelTabs":"_25nIwzT","tab":"_1KxiKze","selectedTab":"_KpA2J5a","panel":"__8uY2WN"};